import DxoBody from './dxo-body';
import PropTypes from 'prop-types';
import CommentBody from './comment-body';
import StandardBody from './standard-body';
import ContactCard from 'apps/contact/components/contact-card/contact-card';
import ContactField from 'apps/interactions/form/fields/shared-fields/contact-field';
import InteractionFormContainer from 'apps/interactions/form/components/interaction-form-container';
import { DynamicField, isEmpty } from '@evertrue/sdk';
import { InteractionFormController } from 'apps/interactions/form/interaction-form-controller';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';

/**
 * This component is unfortunately necessary, because DXO Ask and Comment logic was shoehorned into the interaction form.
 * Eventually, we would like to move that stuff to a new form all together, but for now, we need to keep this logic in place.
 * As such, this component handles the rendering of the body of the interaction form based on the type of interaction.
 * we do NOT use FieldTrigger/Conditional Field rules here, because it creates conflicts with the DXO Ask and Comment logic.
 */
const InteractionFormBody = ({
  // Formik Props
  handleSubmit,
  handleChange,
  setFieldValue,
  values,
  errors,
  dirty,
  isValid,
  touched,
  submitCount = 0,
  // There are tons of additional props that are passed down from the Formik form, but we don't destructure them all here.

  // Custom Props
  contact = {},
  contactOptions = [],
  referrer,
  requestHide = () => {},
  saveLabel,
  cancelLabel,
}) => {
  const { hasInteractionWrites } = useInteractionFormContext();
  const contactId = contact?.id || values?.target_id;
  const isComment = values.interaction_type === InteractionFormController.commentType;
  const isDxoAsk = values.interaction_type === InteractionFormController.dxoAskType;

  return (
    <InteractionFormContainer
      isPinned={values?.pinned}
      isComment={isComment}
      saveLabel={saveLabel}
      cancelLabel={cancelLabel}
      hasInteractionWrites={hasInteractionWrites}
      handleSubmit={handleSubmit}
      onCancel={requestHide}
    >
      {submitCount > 0 && !isValid && <div className="formik-field-error">Please resolve errors before submitting</div>}

      {!isEmpty(contact) ? (
        <ContactCard contact={contact} visibleData={['roleWithYear']} showNameLink={false} />
      ) : (
        <DynamicField
          name="target_id"
          label="Constituent"
          values={values}
          as={ContactField}
          contactOptions={contactOptions}
        />
      )}
      {isComment ? (
        <CommentBody
          values={values}
          contactId={contactId}
          requestHide={requestHide}
          isPinned={referrer === InteractionFormController.pinnedCommentReferrer}
        />
      ) : isDxoAsk ? (
        <DxoBody values={values} />
      ) : (
        <StandardBody values={values} contactId={contactId} referrer={referrer} />
      )}
    </InteractionFormContainer>
  );
};

InteractionFormBody.propTypes = {
  // Formik Props
  handleSubmit: PropTypes.func,
  handleChange: PropTypes.func,
  setFieldValue: PropTypes.func,
  values: PropTypes.object,
  errors: PropTypes.object,
  dirty: PropTypes.bool,
  isValid: PropTypes.bool,
  touched: PropTypes.object,
  submitCount: PropTypes.number,
  // Custom Props
  contact: PropTypes.object,
  contactOptions: PropTypes.array,
  referrer: PropTypes.string,
  requestHide: PropTypes.func.isRequired,
  saveLabel: PropTypes.any,
  cancelLabel: PropTypes.any,
};

export default InteractionFormBody;
